<template>
  <div
    id="app"
    v-touch:right="onSwipeLeft"
  >
    <router-view v-if="loaded" />
    <!--   <div class="download_box" v-if="is_show_footer && app.is_disable === 'Y' && is_show_down_app">
            <a :href="app.app_link" class="down">
                <div class="down_left">
                    <span class="app_logo" v-bind:style="{'background-image':'url(' + app.image + ')'}"></span>
                    <div class="app_info">
                        {{app.text1}}<br>{{app.text2}}
                    </div>
                </div>
                <div class="right">App客户端</div>
            </a>
            <span class="close_down" @click="closeDownApp"></span>
        </div> -->
    <div
      v-if="is_show_footer"
      class="footer"
    >
      <router-link
        to="/"
        class="footer_item"
        :class="show_icon_type === 'index' ? 'footer_item_active' : ''"
      >
        <van-icon
          v-if="show_icon_type == 'index'"
          name="wap-home"
          size="25"
        />
        <van-icon
          v-if="show_icon_type != 'index'"
          name="wap-home-o"
          size="25"
        />
        <p class="footer_info">
          {{ $t('home.index') }}
        </p>
      </router-link>
      <router-link
        to="/ordering"
        class="footer_item"
        :class="show_icon_type === 'ordering' ? 'footer_item_active' : ''"
      >
        <van-icon
          v-if="show_icon_type == 'ordering'"
          name="todo-list"
          size="25"
        />
        <van-icon
          v-if="show_icon_type != 'ordering'"
          name="todo-list-o"
          size="25"
        />
        <p class="footer_info">
          {{ $t('shopd.order') }}
        </p>
      </router-link>

      <router-link
        to="/grap"
        class="footer_item ismid"
        :class="show_icon_type === 'grap' ? 'footer_item_active' : ''"
      >
        <div class="itimg">
          <img
            src="./views/images/shop2/grab.png"
            width="50px"
            height="50px"
            draggable="false"
          >
          <!-- <van-icon v-if="show_icon_type == 'grap'" name="shopping-cart" size="35" class="icon"/>
					<van-icon v-if="show_icon_type != 'grap'" name="shopping-cart-o" size="35" class="icon"/> -->
        </div>
        <p class="footer_info">
          {{ $t('shopd.grab') }}
        </p>
      </router-link>
			
      <router-link
        to="/kefu"
        class="footer_item"
        :class="show_icon_type === 'moneybag' ? 'footer_item_active' : ''"
      >
        <van-icon
          v-if="show_icon_type == 'moneybag'"
          name="service"
          size="25"
        />
        <van-icon
          v-if="show_icon_type != 'moneybag'"
          name="service-o"
          size="25"
        />
        <p class="footer_info">
          {{ $t('user.help') }}
          <!-- {{$t('home.team')}} -->
        </p>
      </router-link>
      <router-link
        to="/user"
        class="footer_item"
        :class="show_icon_type === 'user' ? 'footer_item_active' : ''"
      >
        <van-icon
          v-if="show_icon_type == 'user'"
          name="contact"
          size="25"
        />
        <van-icon
          v-if="show_icon_type != 'user'"
          name="contact-o"
          size="25"
        />
        <p class="footer_info">
          {{ $t('home.my') }}
        </p>
      </router-link>
    </div>
		
    <div
      v-show="real_name"
      class="real_name_mask"
    >
      <div class="real_box">
        <div class="tit" />
        <p class="tips">
          {{ $t('index.moneyset') }}
        </p>
        <div
          class="basic_btn"
          @click="real_name = false"
        >
          {{ $t('index.setnow') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import Vue from 'vue';
	import {
		Icon,
		Popup,
		Dialog
	} from 'vant';
	import Fetch from "./utils/fetch";
	Vue.use(Icon).use(Popup);
	export default {
		name: 'App',
		data() {
			return {
				show_icon_type: 'index',
				msg:null,
				show:false,
				real_name: false,
				is_show_down_app: true,
				is_show_footer: true,
				sync_timer: null,
				app: {},
				loaded:false
			}
		},
		updated() {
			document.body.scrollTop = 0
			document.documentElement.scrollTop = 0
		},
		mounted() {
			this.start();
		},
		methods: {
			onSwipeLeft (even,start,end) {
				console.log();
				if(end['X']-start['X']>60){
					this.$router.go(-1);
				}
			},
			bigNumeber(str) {
				var str = str.toString();
				var strs = str.split(".");
				var s1 = strs[0] || 0;
				var s2 = strs[1] || "00"
				return `<span class="bigNum">${s1}</span><span>.</span><span>${s2}</span>`;
			},
			numFilter(value) {
				let transformVal = parseFloat(value).toFixed(3)
				let realVal = transformVal.substring(0, transformVal.length - 1)
				return parseFloat(realVal)
			},
			footer: function(type = 'index', show_footer = true) {
				if (type == 'walfare') {
					document.getElementById('app').style.paddingBottom = '0';
				} else {
					document.getElementById('app').style.paddingBottom = '1.333333rem';
				}
				this.show_icon_type = type;
				this.is_show_footer = show_footer;
			},
			start() {
				Fetch("/index/webconfig").then((r) => {
					this.app = r.data;
					window.document.title = r.data.title;
					this.$i18n.locale = r.data.lang;
					localStorage.setItem("lang", r.data.lang);
					localStorage.setItem("moneyMark", r.data.money_mark);
					this.loaded = true;
				});

				// setTimeout(()=>{
				//   this.sync()
				// },2000)
			},
			close() {
				this.show_anwser = false;
			},
			closeDownApp() {
				this.is_show_down_app = false;
			},
			sync() {
				// Fetch("/index/sync", {}, null, false).then((r) => {
				//   // if (r.data>0) {
				// 	this.openNoticeDialog(r.data);
				//   // }
				// });
			},
			openNoticeDialog(data) {
				if(data && data.length>0){
					this.msg = data[0].content;
					this.show= true;
					Fetch('/user/notice_view', {
					    id: data[0].id
					}).then(res => {
					})
				}
				// Dialog.confirm({
				//   title: this.$t('notice.message'),
				//   message: num+this.$t('notice.unRead')
				// }).then(() => {
				//   this.$router.push('/notice');
				// }).catch(() => {
				// });
			},
		}
	}
</script>
<style lang="less">

	@import "./assets/font/font.css";
	.kefu {
		width: 60px;
		height: 60px;
		position: fixed;
		z-index: 10;
		right: 13px;
		bottom: 10vh;
		transition: all 1s;
		opacity: 1;
		transform: translateX(0);
		z-index: 80;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.kefu.kefu_hide {
		transform: translateX(70%);
		opacity: 0.5;
	}

	.numberFont {
		font-family: barlow !important;
		font-size: 15px !important;
		font-weight: bold !important;
		span:nth-of-type(3) {
			font-size: 14px !important;
		}
		span:nth-of-type(4) {
			font-size: 12px !important;
		}
	}

	html,
	body {
		width: 100%;
		height: 100%;
		overflow-y: scroll;
	}

	html::-webkit-scrollbar,
	body::-webkit-scrollbar {
		width: 0px;
		height: 0px;
	}

	body {
		margin: 0;
		background: url(./views/images/shop2/2.png) no-repeat top;
		background-size: 100% 100%;
	}

	.bigNum {
		font-size: 18px !important;
	}

	.fh {
		font-size: 12px !important;
	}

	.larfont .fh {
		margin-top: 3px;
	}

	.wan {
		font-size: 14px;
		margin-top: 2px;
	}

	.numberFontBold {
		span:first-child {
			font-size: 12px;
			margin-top: 4px;
		}

		span:last-child {
			margin-top: 2px;
		}
	}
	#app {
		padding-bottom: 0px !important;
		min-height: 100%;
		height: 100vh;
		width: 100%;
		// background-color: #FAFAFA;
		max-width: 720px;
		margin: auto;
		// background-color: #00c0ff;
		// background: url(./views/images/shop2/2.png) no-repeat top;
		// background-size: 100% 100%;
	}
	@media screen and (min-width: 768px) {
		#app {
			width: 500px !important;
		}

		#app .footer {
			width: 476px !important;
		}
		
	}
	

	#app .download_box {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		position: fixed;
		margin: 0 auto;
		left: 0;
		right: 0;
		height: 45px;
		width: 100%;
		max-width: 375px;
		background: rgba(0, 0, 0, 0.5);
		bottom: 50px;
		padding: 0 3.6%;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;
		z-index: 10;
	}

	#app .download_box .down {
		-webkit-box-flex: 1;
		-ms-flex: 1 1 auto;
		flex: 1 1 auto;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-pack: justify;
		-ms-flex-pack: justify;
		justify-content: space-between;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		padding-right: 10px;
	}

	#app .download_box .down .down_left {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
	}

	#app .download_box .down .down_left .app_logo {
		display: inline-block;
		width: 40px;
		height: 40px;
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
		background-image: url(./views/images/home/app_logo.svg);
		margin-right: 14px;
		;
	}

	#app .download_box .down .down_left .app_info {
		font-size: 12px;
		color: #fff;
		line-height: 1.5;
		;
	}

	#app .download_box .down .right {
		background: #D8232C;
		padding: 5px 5px;
		color: #ffffff;
		border-radius: 5px;
		font-size: 12px;
	}

	#app .download_box .close_down {
		-webkit-box-flex: 0;
		-ms-flex: 0 0 20px;
		flex: 0 0 20px;
		height: 45px;
		;
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
		background-image: url(./views/images/home/close.svg);
	}

	#app .footer {
		position: fixed;
		margin: 0 auto;
		left: 12px;
		right: 12px;
		-webkit-box-flex: 0;
		-ms-flex: 0 0 64px;
		flex: 0 0 64px;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-ms-flex-pack: distribute;
		justify-content: space-around;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		width: calc(100% - 24px);
		max-width: 696px;
		height: 64px;
		bottom: calc(10px + env(safe-area-inset-bottom));
		border: 1px solid rgba(255, 255, 255, .82);
		border-radius: 20px;
		background: rgba(255, 255, 255, .94);
		box-shadow: 0 12px 28px rgba(31, 45, 66, .14);
		box-sizing: border-box;
		-webkit-backdrop-filter: blur(14px);
		backdrop-filter: blur(14px);
		z-index: 1000;
	}

	#app .footer .footer_item {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: center;
		-webkit-box-orient: vertical;
		-webkit-box-direction: normal;
		-ms-flex-direction: column;
		flex-direction: column;
		position: relative;
		justify-content: center;
		height: 100%;
		padding: 8px 0 7px;
		box-sizing: border-box;
		cursor: pointer;
		color: #40516a;
		width: 20%;
		min-width: 0;
		text-align: center;
		transition: color .18s ease, transform .18s ease;

		&:active {
			transform: translateY(1px);
		}
	}

	#app .footer .footer_item > .van-icon {
		height: 25px;
		margin-bottom: 2px;
		line-height: 25px;
	}

	#app .footer .footer_item .footer_icon {
		display: inline-block;
		width: 26px;
		height: 26px;
		background-repeat: no-repeat;
		background-size: contain;
		background-position: center;
		margin-bottom: 6px;
	}

	#app .footer .footer_item .footer_icon.footer_icon_home {
		background-image: url(./views/images/shop2/home_line.png);
	}

	#app .footer .footer_item .footer_icon.footer_icon_task {
		background-image: url(./views/images/shop2/funds_line.png);
	}

	#app .footer .footer_item .footer_icon.footer_icon_cart {
		background-image: url(./views/images/common/activity.png);
	}
	#app .footer .footer_item .footer_icon.footer_icon_money {
		background-image: url(./views/images/shop2/item_1.png);
	}
	#app .footer .footer_item .footer_icon.footer_icon_activity_1 {
		background-image: url(./views/images/shop2/share_line.png);
	}
	#app .footer .footer_item .footer_icon.footer_icon_user {
		background-image: url(./views/images/shop2/mine_line.png);
	}

	#app .footer .footer_item .footer_info {
		width: 100%;
		overflow: hidden;
		margin: 0;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 12px;
		line-height: 18px;
	}

	#app .footer .footer_item.footer_item_active {
		color: #FF385C;
		font-weight: 600;
	}

	#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_home {
		background-image: url(./views/images/shop2/home_green.png);
	}

	#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_task {
		background-image: url(./views/images/shop2/funds_green.png);
	}
	#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_money {
		background-image: url(./views/images/shop2/item_cur_1.png);
	}
	#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_activity_1 {
		background-image: url(./views/images/shop2/share_green.png);
	}
	
	
	#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_cart {
		background-image: url(./views/images/shop2/share_green.png);
	}

	#app .footer .footer_item.footer_item_active .footer_icon.footer_icon_user {
		background-image: url(./views/images/shop2/mine_green.png);
	}

	.red_top_bg {
		width: 100%;
		max-width: 750px;
		height: 44px;
		margin: 0 auto;
		background: #FFF;
		background-size: 100% 100%;
		overflow: hidden;
		background-color: #D20100cc;
		color: rgb(255, 255, 255);
		height: 44px;
		background-size: 100% 100%;
		position: relative;
		border-radius: 0;
	}

	.top_right {
		position: absolute;
		font-size: 13px;
		line-height: 18px;
		color: #FFFFFF;
		top: 10px;
		right: 10px;
	}

	.limit {
		height: 20px;
		line-height: 20px;
		border-radius: 10px;
		background: rgba(241, 34, 17, 0.08);
		color: #f12211;
		text-align: center;
		padding: 0 7px;
		border: 1px solid #f12211;
		font-size: 12px;
	}

	.gray_btn {
		height: 20px;
		align-items: center;
		background: rgba(0, 0, 0, 0.3);
		font-size: 12px;
		text-align: center;
		color: #FFFFFF;
		border-radius: 10px;
		padding: 0 9px;
	}
	.rechargebtn{
		 // background: linear-gradient(270deg,#746b0a,#f90);
		 
		 background: linear-gradient(1turn, #FF6666, #746b0a);
	}
	.withdrawbtn{
		// background: linear-gradient(270deg,#746b0a,#056150);
		
		background: linear-gradient(1turn, #339999, #746b0a);
	}
	.big_tit {
		position: absolute;
		height: 25px;
		font-size: 16px;
		font-weight: 500;
		line-height: 25px;
		top: 12px;
		left: 50%;
		transform: translateX(-50%);
	}

	.sub_btn {
		background: linear-gradient(1turn,#36333d, #746b0a);
		height: 30px;
		font-size: 12px;
		color: #FFFFFF;
		text-align: center;
		width: 94px;
		border-radius: 5px;
	}

	.remove_btn {
		background: linear-gradient(117deg, rgba(254, 166, 0, 1) 0%, rgba(255, 188, 0, 1) 100%);
		height: 36px;
		line-height: 36px;
		font-size: 12px;
		color: #FFFFFF;
		text-align: center;
		width: 94px;
		border-radius: 18px;
	}

	.home_tit {
		width: 100%;
		height: 22px;
		line-height: 22px;
		display: flex;
		align-items: center;
		justify-content: center;

		.line {
			width: 75px;
			height: 2px;
		}

		h5 {
			font-size: 16px;
			line-height: 22px;
			color: #000000;
			margin: 0 10px;
			font-weight: bold;
		}
	}

	.van-popup {
		max-width: 100%;
		margin: 0 auto;
		right: 0;
	}

	.back_left {
		width: 20px;
		height: 20px;
		background: url(./views/images/item/back.png) no-repeat center center;
		background-size: auto 100%;
		margin: 12px 0 0 8px;
	}
	.getcode {
		background:linear-gradient(270deg,#36333d, #746b0a);
	}
	.basic_btn {
		height: 45px;
		line-height: 45px;
		font-size: 16px;
		width: 90%;
		border-radius: 5px;
		// background: linear-gradient(1turn,#36333d, #746b0a);
		// background: #746b0a;
		color: #fff;
		text-align: center;
		background-color: #232f3e;
		color: #ffcd00;
		box-shadow: rgba(41,5,5,.15) -5px 10px 10px;
		margin: 3% 0;
		border: 10px;
	}

	.basic_btn.no_touch {
		color: rgba(255, 255, 255, 0.5);
	}

	.flex_center {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.wrap_box {
		// width: 100%;
		background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 9px 2px rgba(160, 160, 160, 0.15);
		border-radius: 6px;
	}

	.eye_bi {
		width: 21px;
		height: 25px;
		background: url(./views/images/user/eye2.png) no-repeat center center;
		background-size: 100% auto;

		&.eye {
			background: url(./views/images/user/eye1.png) no-repeat center center;
			background-size: 100% auto;
		}
	}

	.real_name_mask {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: 30;
		background-color: rgba(0, 0, 0, 0.95);

		.real_box {
			width: 272px;
			height: 185px;
			background: rgba(255, 255, 255, 1);
			border-radius: 8px;
			position: absolute;
			top: 50%;
			left: 0;
			right: 0;
			margin: -92px auto 0 auto;

			.tit {
				width: 77px;
				height: 67px;
				position: absolute;
				top: -35px;
				left: 50%;
				transform: translateX(-50%);
				background: url(./views/images/user/tit.png) no-repeat center center;
				background-size: 100% 100%;
			}

			.tips {
				width: 185px;
				height: 50px;
				text-align: center;
				font-size: 18px;
				color: #000000;
				line-height: 25px;
				position: absolute;
				top: 49px;
				left: 50%;
				transform: translateX(-50%);
			}

			.basic_btn {
				width: 225px;
				position: absolute;
				left: 0;
				right: 0;
				margin: 0 auto;
				bottom: 15px;
			}
		}
	}

	.contract_box img {
		width: 100%;
	}
	.kefu_img{
		border-radius: 80px;
	}
	input::placeholder{
		color: grey;
	}
	#app .footer .footer_item.ismid {
		justify-content: flex-end;
		padding-bottom: 7px;

		.itimg {
			position: absolute;
			bottom: 25px;
			left: 50%;
			z-index: 1;
			width: 62px;
			height: 62px;
			padding: 4px;
			border: 3px solid #FFFFFF;
			border-radius: 50%;
			background: #FFF7D7;
			box-shadow: 0 8px 18px rgba(58, 53, 38, .18);
			box-sizing: border-box;
			transform: translateX(-50%);

			img {
				display: block;
				width: 100%;
				height: 100%;
				border-radius: 50%;
			}
		}
	}
	.bgdeep{
		
	}
	.but1{
	    background-color: #ffcd00;
	    color: #232f3e;
	}
	.but2{
	    background-color: #232f3e;
	    color: #ffcd00;
	}
/deep/ .van-popup--center{
	line-height: 30px;
	padding: 10px;
	border-radius: 5px;
	font-weight: bold;
}

.toastc{
	width:60% !important;
}
.shadow {
	border-radius: 6px !important;
    box-shadow: 0 .3rem 0.6rem rgba(0, 0, 0, .1) !important;
    -webkit-box-shadow: 0 .3rem 0.6rem rgba(0, 0, 0, .1) !important;
    -moz-box-shadow: 0 .3rem 0.6rem rgba(0, 0, 0, .1) !important;
    -ms-box-shadow: 0 .3rem 0.6rem rgba(0, 0, 0, .1) !important;
	box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1) !important;
}
.colorfull{
	background: linear-gradient(to right, red, orange, yellow, green, cyan, blue, purple);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	animation: hue 3s linear infinite;
}
.dialogstyle{
	top: 60% !important;
}
/deep/ .dialogstyle{
	top: 60% !important;
}

/* Unified business-page header — keep every .red_top_bg aligned with user/pay.vue. */
#app .red_top_bg {
	position: relative;
	width: 100%;
	max-width: 750px;
	height: 50px !important;
	margin: 0 auto;
	overflow: visible;
	border: 0;
	border-bottom: 1px solid rgba(235, 235, 235, 0.9) !important;
	border-radius: 0 !important;
	background: rgba(255, 255, 255, 0.9) !important;
	box-shadow: none !important;
	color: #222 !important;
	backdrop-filter: blur(10px);
}

#app .red_top_bg .big_tit {
	position: absolute;
	top: 0 !important;
	left: 50%;
	width: calc(100% - 88px);
	height: 50px !important;
	overflow: hidden;
	color: #222 !important;
	font-size: 14px !important;
	font-weight: 700 !important;
	line-height: 50px !important;
	text-align: center;
	text-overflow: ellipsis;
	white-space: nowrap;
	transform: translateX(-50%);
}

#app .red_top_bg .back_left {
	position: absolute;
	z-index: 2;
	top: 0 !important;
	left: 0 !important;
	width: 44px !important;
	height: 50px !important;
	margin: 0 !important;
	border-radius: 0 !important;
	background: none !important;
	cursor: pointer;
}

#app .red_top_bg .back_left::after {
	position: absolute;
	top: 18px;
	left: 17px;
	width: 11px;
	height: 11px;
	border-top: 0 !important;
	border-right: 0 !important;
	border-bottom: 2px solid #484848 !important;
	border-left: 2px solid #484848 !important;
	content: '' !important;
	transform: rotate(45deg) !important;
}

#app .red_top_bg .top_right {
	position: absolute;
	z-index: 2;
	top: 0 !important;
	right: 0 !important;
	box-sizing: border-box;
	display: flex !important;
	width: 44px !important;
	height: 50px !important;
	align-items: center !important;
	justify-content: center !important;
	color: #484848 !important;
	font-size: 18px !important;
	line-height: 1 !important;
}

#app .red_top_bg .top_right .van-icon {
	color: inherit !important;
	font-size: 18px !important;
}
</style>
